import styled from "@emotion/styled";

export const CenteredContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;